import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Relements
import Box from 'relements/build/esm/ui/box';
import Text from 'relements/build/esm/ui/text';
import Button from 'relements/build/esm/ui/button';

// Icons
import OpenLinkIcon from 'relements/build/esm/ui/icons/OpenLinkIcon';

// Actions
import {
  fetchTestConfiguration,
  fetchTestConfigurationBusinessPartner,
} from 'actions/DomainActions';

// Stores
import BusinessStore from 'stores/BusinessStore';
import CommonStore from 'stores/CommonStore';
import BotStore from '@src/store';

// Components
import CopyCard from './components/CopyCard';

// Utils
import connection from '../../../connection';

const StyledLink = styled.a`
  text-decoration: none;
  ${(props) => `color: ${props.theme.colors.blue.haptik};`}
`;

const StyledButton = styled(Button)({
  width: 116,
  height: 36,
});

const leftCardStyles = {
  width: '378px',
  marginRight: '17px',
};

const rightCardStyles = {
  width: '142px',
};

function getStateFromStores() {
  return {
    testConfiguration: BusinessStore.getTestConfiguration(),
    meta: CommonStore.getMetaTags(),
  };
}

/**
 * Component which fetches and shows the details for deploying and sharing a bot
 *
 * @export
 * @class ShareBot
 * @extends {React.Component}
 */
@connection([BusinessStore], getStateFromStores)
export default class ShareBot extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clientId: null,
      baseUrl: null,
      apiKey: null,
      businessId: null,
    };
  }

  componentDidMount() {
    if (this.props.botId) {
      if (!BotStore.getSelfServeLayout()) {
        fetchTestConfiguration(this.props.botId);
      } else {
        const testConfigDataForBot = BotStore.getTestConfigData();
        this.setState({
          clientId: testConfigDataForBot.partner_client_id,
          baseUrl: testConfigDataForBot.base_url,
          apiKey: testConfigDataForBot.partner_api_key,
          businessId: testConfigDataForBot.business_id,
        });
      }
    } else {
      fetchTestConfigurationBusinessPartner(
        this.props.businessId,
        this.props.partner
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    const testConfigDataForBot = nextProps.testConfiguration || {};

    this.setState({
      clientId: testConfigDataForBot.partner_client_id,
      baseUrl: testConfigDataForBot.base_url,
      apiKey: testConfigDataForBot.partner_api_key,
      businessId: testConfigDataForBot.business_id,
      pipelineVersion: nextProps.meta.domain.pipeline_version
        ? nextProps.meta.domain.pipeline_version.toFixed(1)
        : 'N/A',
    });
  }

  onDemoLinkButtonClicked = () => {
    const {
      clientId = null,
      baseUrl = null,
      apiKey = null,
      businessId = null,
    } = this.state;

    const botLink =
      'https://toolassets.haptikapi.com/js-sdk/html/demoqp.html' +
      `?business-id=${businessId}` +
      `&client-id=${clientId}` +
      `&api-key=${apiKey}` +
      `&base-url=${baseUrl}` +
      '&xdk=true';

    window.open(botLink, '_blank');
  };

  onHowToDeployClicked() {
    window.open(
      'https://haptik-docs.readthedocs.io/en/latest/bot-configuration/client-sdk.html',
      '_blank'
    );
  }

  render() {
    const {
      clientId = null,
      baseUrl = null,
      businessId = null,
      pipelineVersion = null,
    } = this.state;

    return (
      <Box padding="21px 25px" width="100%" flexDirection="column">
        <Box padding="0px">
          <CopyCard
            title="Account ID"
            subtitle={clientId}
            style={leftCardStyles}
          />
          <CopyCard
            title="Business ID"
            subtitle={businessId}
            style={rightCardStyles}
          />
        </Box>
        <Box padding="0px" marginTop="17px">
          <CopyCard
            title="Base URL"
            subtitle={baseUrl}
            style={leftCardStyles}
          />
          <CopyCard
            title="Pipeline Version"
            subtitle={pipelineVersion}
            style={rightCardStyles}
          />
        </Box>
        <Box padding="0px" marginTop="20px" justifyContent="space-between">
          <Box padding="0px" width="351px" flexDirection="column">
            <Text variant="body.xs">
              This link can be shared with users outside of the Haptik platform.
            </Text>
            <Text variant="body.xs">
              Test link is for testing purposes only. To make your bot live, you
              must deploy it.
            </Text>
            <Text variant="body.xs">
              <StyledLink
                href="https://docs.haptik.ai/web-sdk/how-to-deploy-a-bot-on-my-website"
                target="_blank"
              >
                Know more
              </StyledLink>{' '}
              about how to make your bot live.
            </Text>
          </Box>
          <StyledButton themed onClick={this.onDemoLinkButtonClicked}>
            <Box padding="0px" alignItems="center">
              <Text variant="h3.semi-bold" color="grey.pastel">
                Test Link
              </Text>
              <OpenLinkIcon
                size="small"
                iconColor="grey.pastel"
                style={{ marginLeft: '8px' }}
              />
            </Box>
          </StyledButton>
        </Box>
      </Box>
    );
  }
}

ShareBot.propTypes = {
  testConfiguration: PropTypes.object,
  botId: PropTypes.string,
};
